var _excluded = ["instanceId", "containerNode"];
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { createAutocompleteComponent, createAutocompleteIndexComponent, createAutocompletePanelComponent, createAutocompletePropGetters, createAutocompleteRecentSearchComponent, createAutocompleteSearchComponent, createAutocompleteStorage, createAutocompleteSuggestionComponent, cx } from 'instantsearch-ui-components';
import { Fragment, h, render } from 'preact';
import { useEffect, useId, useMemo, useRef, useState } from 'preact/hooks';
import TemplateComponent from "../../components/Template/Template.js";
import { connectAutocomplete, connectSearchBox } from "../../connectors/index.umd.js";
import { ReverseHighlight } from "../../helpers/components/index.js";
import { component } from "../../lib/suit.js";
import { prepareTemplateProps } from "../../lib/templating/index.js";
import { createDocumentationMessageGenerator, getContainerNode, walkIndex } from "../../lib/utils/index.js";
import configure from "../configure/configure.js";
import index from "../index/index.js";
var autocompleteInstanceId = 0;
var withUsage = createDocumentationMessageGenerator({
  name: 'autocomplete'
});
var suit = component('Autocomplete');
var Autocomplete = createAutocompleteComponent({
  createElement: h,
  Fragment: Fragment
});
var AutocompletePanel = createAutocompletePanelComponent({
  createElement: h,
  Fragment: Fragment
});
var AutocompleteIndex = createAutocompleteIndexComponent({
  createElement: h,
  Fragment: Fragment
});
var AutocompleteSuggestion = createAutocompleteSuggestionComponent({
  createElement: h,
  Fragment: Fragment
});
var AutocompleteSearchBox = createAutocompleteSearchComponent({
  createElement: h,
  Fragment: Fragment
});
var AutocompleteRecentSearch = createAutocompleteRecentSearchComponent({
  createElement: h,
  Fragment: Fragment
});
var usePropGetters = createAutocompletePropGetters({
  useEffect: useEffect,
  useId: useId,
  useMemo: useMemo,
  useRef: useRef,
  useState: useState
});
var useStorage = createAutocompleteStorage({
  useEffect: useEffect,
  useState: useState,
  useMemo: useMemo
});
var createRenderer = function createRenderer(params) {
  var instanceId = params.instanceId,
    containerNode = params.containerNode,
    rendererParams = _objectWithoutProperties(params, _excluded);
  return function (connectorParams, isFirstRendering) {
    if (isFirstRendering) {
      var _targetIndex$getHelpe, _targetIndex$getHelpe2;
      var isolatedIndex = connectorParams.instantSearchInstance.mainIndex;
      var targetIndex = connectorParams.instantSearchInstance.mainIndex;
      walkIndex(targetIndex, function (childIndex) {
        if (childIndex.getIndexId() === "ais-autocomplete-".concat(instanceId)) {
          isolatedIndex = childIndex;
          targetIndex = childIndex.parent;
        }
      });
      rendererParams.renderState = {
        indexTemplateProps: [],
        isolatedIndex: isolatedIndex,
        targetIndex: targetIndex,
        templateProps: prepareTemplateProps({
          defaultTemplates: {},
          templatesConfig: connectorParams.instantSearchInstance.templatesConfig,
          templates: rendererParams.templates
        })
      };
      connectorParams.refine((_targetIndex$getHelpe = (_targetIndex$getHelpe2 = targetIndex.getHelper()) === null || _targetIndex$getHelpe2 === void 0 ? void 0 : _targetIndex$getHelpe2.state.query) !== null && _targetIndex$getHelpe !== void 0 ? _targetIndex$getHelpe : '');
      return;
    }
    render(h(AutocompleteWrapper, _extends({}, rendererParams, connectorParams)), containerNode);
  };
};
function AutocompleteWrapper(_ref) {
  var _isolatedIndex$getHel, _targetIndex$getWidge, _showRecent$templates;
  var indicesConfig = _ref.indicesConfig,
    indices = _ref.indices,
    getSearchPageURL = _ref.getSearchPageURL,
    userOnSelect = _ref.onSelect,
    refine = _ref.refine,
    cssClasses = _ref.cssClasses,
    renderState = _ref.renderState,
    instantSearchInstance = _ref.instantSearchInstance,
    showRecent = _ref.showRecent,
    showSuggestions = _ref.showSuggestions,
    templates = _ref.templates;
  var isolatedIndex = renderState.isolatedIndex,
    targetIndex = renderState.targetIndex;
  var searchboxQuery = isolatedIndex === null || isolatedIndex === void 0 ? void 0 : (_isolatedIndex$getHel = isolatedIndex.getHelper()) === null || _isolatedIndex$getHel === void 0 ? void 0 : _isolatedIndex$getHel.state.query;
  var _useStorage = useStorage({
      query: searchboxQuery,
      showRecent: showRecent,
      indices: indices,
      indicesConfig: indicesConfig
    }),
    storage = _useStorage.storage,
    storageHits = _useStorage.storageHits,
    indicesConfigForPropGetters = _useStorage.indicesConfigForPropGetters,
    indicesForPropGetters = _useStorage.indicesForPropGetters;
  var isSearchPage = (_targetIndex$getWidge = targetIndex === null || targetIndex === void 0 ? void 0 : targetIndex.getWidgets().some(function (_ref2) {
    var $$type = _ref2.$$type;
    return ['ais.hits', 'ais.infiniteHits'].includes($$type);
  })) !== null && _targetIndex$getWidge !== void 0 ? _targetIndex$getWidge : false;
  var onRefine = function onRefine(query) {
    instantSearchInstance.setUiState(function (uiState) {
      var _objectSpread2;
      return _objectSpread(_objectSpread({}, uiState), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, targetIndex.getIndexId(), _objectSpread(_objectSpread({}, uiState[targetIndex.getIndexId()]), {}, {
        query: query
      })), _defineProperty(_objectSpread2, isolatedIndex.getIndexId(), {
        query: query
      }), _objectSpread2));
    });
    query.length > 0 && storage.onAdd(query);
  };
  var _usePropGetters = usePropGetters({
      indices: indicesForPropGetters,
      indicesConfig: indicesConfigForPropGetters,
      onRefine: onRefine,
      onSelect: userOnSelect !== null && userOnSelect !== void 0 ? userOnSelect : function (_ref3) {
        var query = _ref3.query,
          setQuery = _ref3.setQuery,
          url = _ref3.url;
        if (url) {
          window.location.href = url;
          return;
        }
        if (!isSearchPage && typeof getSearchPageURL !== 'undefined') {
          var indexUiState = instantSearchInstance.getUiState()[targetIndex.getIndexId()];
          window.location.href = getSearchPageURL(_objectSpread(_objectSpread({}, indexUiState), {}, {
            query: query
          }));
          return;
        }
        setQuery(query);
      }
    }),
    getInputProps = _usePropGetters.getInputProps,
    getItemProps = _usePropGetters.getItemProps,
    getPanelProps = _usePropGetters.getPanelProps,
    getRootProps = _usePropGetters.getRootProps;
  var AutocompleteRecentSearchComponent = function AutocompleteRecentSearchComponent(_ref4) {
    var item = _ref4.item,
      onSelect = _ref4.onSelect,
      onRemoveRecentSearch = _ref4.onRemoveRecentSearch;
    return h(AutocompleteRecentSearch, {
      item: item,
      onSelect: onSelect,
      onRemoveRecentSearch: onRemoveRecentSearch
    }, h(ConditionalReverseHighlight, {
      item: item
    }));
  };
  if (_typeof(showRecent) === 'object' && (_showRecent$templates = showRecent.templates) !== null && _showRecent$templates !== void 0 && _showRecent$templates.item) {
    var props = prepareTemplateProps({
      defaultTemplates: {},
      templatesConfig: instantSearchInstance.templatesConfig,
      templates: showRecent.templates
    });
    AutocompleteRecentSearchComponent = function AutocompleteRecentSearchComponent(_ref5) {
      var item = _ref5.item,
        onSelect = _ref5.onSelect,
        onRemoveRecentSearch = _ref5.onRemoveRecentSearch;
      return h(TemplateComponent, _extends({}, props, {
        templateKey: "item",
        rootTagName: "fragment",
        data: {
          item: item,
          onSelect: onSelect,
          onRemoveRecentSearch: onRemoveRecentSearch
        }
      }));
    };
  }
  var elements = {};
  if (showRecent) {
    elements.recent = h(AutocompleteIndex
    // @ts-ignore - there seems to be problems with React.ComponentType and this, but it's actually correct
    , {
      ItemComponent: function ItemComponent(_ref6) {
        var item = _ref6.item,
          onSelect = _ref6.onSelect;
        return h(AutocompleteRecentSearchComponent, {
          item: item,
          onSelect: onSelect,
          onRemoveRecentSearch: function onRemoveRecentSearch() {
            return storage.onRemove(item.query);
          }
        });
      },
      classNames: {
        root: 'ais-AutocompleteRecentSearches',
        list: 'ais-AutocompleteRecentSearchesList',
        item: 'ais-AutocompleteRecentSearchesItem'
      },
      items: storageHits,
      getItemProps: getItemProps
    });
  }
  indices.forEach(function (_ref7, i) {
    var _indicesConfig$i$temp;
    var indexId = _ref7.indexId,
      indexName = _ref7.indexName,
      hits = _ref7.hits;
    if (!renderState.indexTemplateProps[i]) {
      renderState.indexTemplateProps[i] = prepareTemplateProps({
        defaultTemplates: {},
        templatesConfig: instantSearchInstance.templatesConfig,
        templates: indicesConfig[i].templates
      });
    }
    var headerComponent = (_indicesConfig$i$temp = indicesConfig[i].templates) !== null && _indicesConfig$i$temp !== void 0 && _indicesConfig$i$temp.header ? function (_ref8) {
      var items = _ref8.items;
      return h(TemplateComponent, _extends({}, renderState.indexTemplateProps[i], {
        templateKey: "header",
        rootTagName: "fragment",
        data: {
          items: items
        }
      }));
    } : undefined;
    var itemComponent = function itemComponent(_ref9) {
      var item = _ref9.item,
        onSelect = _ref9.onSelect;
      return h(TemplateComponent, _extends({}, renderState.indexTemplateProps[i], {
        templateKey: "item",
        rootTagName: "fragment",
        data: {
          item: item,
          onSelect: onSelect
        }
      }));
    };
    var elementId = indexName === (showSuggestions === null || showSuggestions === void 0 ? void 0 : showSuggestions.indexName) ? 'suggestions' : indexName;
    elements[elementId] = h(AutocompleteIndex, {
      key: indexId,
      HeaderComponent: headerComponent,
      ItemComponent: itemComponent,
      items: hits.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          __indexName: indexId
        });
      }),
      getItemProps: getItemProps,
      classNames: indicesConfig[i].cssClasses
    });
  });
  return h(Autocomplete, _extends({}, getRootProps(), {
    classNames: cssClasses
  }), h(AutocompleteSearchBox, {
    query: searchboxQuery || '',
    inputProps: _objectSpread(_objectSpread({}, getInputProps()), {}, {
      // @ts-ignore - This clashes with some ambient React JSX declarations.
      onInput: function onInput(evt) {
        return refine(evt.currentTarget.value);
      }
    }),
    onClear: function onClear() {
      return onRefine('');
    },
    isSearchStalled: instantSearchInstance.status === 'stalled'
  }), h(AutocompletePanel, getPanelProps(), templates.panel ? h(TemplateComponent, _extends({}, renderState.templateProps, {
    templateKey: "panel",
    rootTagName: "fragment",
    data: {
      elements: elements,
      indices: indices
    }
  })) : Object.keys(elements).map(function (elementId) {
    return elements[elementId];
  })));
}
export function EXPERIMENTAL_autocomplete(widgetParams) {
  var _ref0 = widgetParams || {},
    container = _ref0.container,
    escapeHTML = _ref0.escapeHTML,
    _ref0$indices = _ref0.indices,
    indices = _ref0$indices === void 0 ? [] : _ref0$indices,
    showSuggestions = _ref0.showSuggestions,
    showRecent = _ref0.showRecent,
    userSearchParameters = _ref0.searchParameters,
    getSearchPageURL = _ref0.getSearchPageURL,
    onSelect = _ref0.onSelect,
    _ref0$templates = _ref0.templates,
    templates = _ref0$templates === void 0 ? {} : _ref0$templates,
    _ref0$cssClasses = _ref0.cssClasses,
    userCssClasses = _ref0$cssClasses === void 0 ? {} : _ref0$cssClasses;
  if (!container) {
    throw new Error(withUsage('The `container` option is required.'));
  }
  var containerNode = getContainerNode(container);
  var searchParameters = _objectSpread({
    hitsPerPage: 5
  }, userSearchParameters);
  var cssClasses = {
    root: cx(suit(), userCssClasses.root)
  };
  var indicesConfig = _toConsumableArray(indices);
  if (showSuggestions !== null && showSuggestions !== void 0 && showSuggestions.indexName) {
    var _showSuggestions$cssC, _showSuggestions$cssC2, _showSuggestions$cssC3, _showSuggestions$cssC4;
    indicesConfig.unshift({
      indexName: showSuggestions.indexName,
      templates: _objectSpread({
        // @ts-expect-error
        item: function item(_ref1) {
          var _item = _ref1.item,
            onSelectItem = _ref1.onSelect;
          return h(AutocompleteSuggestion, {
            item: _item,
            onSelect: onSelectItem
          }, h(ConditionalReverseHighlight, {
            item: _item
          }));
        }
      }, showSuggestions.templates),
      cssClasses: {
        root: cx('ais-AutocompleteSuggestions', (_showSuggestions$cssC = showSuggestions.cssClasses) === null || _showSuggestions$cssC === void 0 ? void 0 : _showSuggestions$cssC.root),
        list: cx('ais-AutocompleteSuggestionsList', (_showSuggestions$cssC2 = showSuggestions.cssClasses) === null || _showSuggestions$cssC2 === void 0 ? void 0 : _showSuggestions$cssC2.list),
        header: cx('ais-AutocompleteSuggestionsHeader', (_showSuggestions$cssC3 = showSuggestions.cssClasses) === null || _showSuggestions$cssC3 === void 0 ? void 0 : _showSuggestions$cssC3.header),
        item: cx('ais-AutocompleteSuggestionsItem', (_showSuggestions$cssC4 = showSuggestions.cssClasses) === null || _showSuggestions$cssC4 === void 0 ? void 0 : _showSuggestions$cssC4.item)
      },
      getQuery: function getQuery(item) {
        return item.query;
      },
      getURL: showSuggestions.getURL
    });
  }
  var instanceId = ++autocompleteInstanceId;
  var specializedRenderer = createRenderer({
    instanceId: instanceId,
    containerNode: containerNode,
    indicesConfig: indicesConfig,
    getSearchPageURL: getSearchPageURL,
    onSelect: onSelect,
    cssClasses: cssClasses,
    showRecent: showRecent,
    showSuggestions: showSuggestions,
    renderState: {
      indexTemplateProps: [],
      isolatedIndex: undefined,
      targetIndex: undefined,
      templateProps: undefined
    },
    templates: templates
  });
  var makeWidget = connectAutocomplete(specializedRenderer, function () {
    return render(null, containerNode);
  });
  return [connectSearchBox(function () {
    return null;
  })({}), index({
    indexId: "ais-autocomplete-".concat(instanceId),
    EXPERIMENTAL_isolated: true
  }).addWidgets([configure(searchParameters)].concat(_toConsumableArray(indicesConfig.map(function (_ref10) {
    var indexName = _ref10.indexName,
      indexSearchParameters = _ref10.searchParameters;
    return index({
      indexName: indexName,
      indexId: indexName
    }).addWidgets([configure(indexSearchParameters || {})]);
  })), [_objectSpread(_objectSpread({}, makeWidget({
    escapeHTML: escapeHTML
  })), {}, {
    $$widgetType: 'ais.autocomplete'
  })]))];
}
function ConditionalReverseHighlight(_ref11) {
  var _item$_highlightResul;
  var item = _ref11.item;
  if (!((_item$_highlightResul = item._highlightResult) !== null && _item$_highlightResul !== void 0 && _item$_highlightResul.query) ||
  // @ts-expect-error - we should not have matchLevel as arrays here
  item._highlightResult.query.matchLevel === 'none') {
    return item.query;
  }
  return h(ReverseHighlight, {
    attribute: "query",
    hit: item
  });
}